<template>
  <div class="spl-export-proof-list-header">
    <form-button @onClick="handleCreateExportProof">
      Create Export Proof
    </form-button>
  </div>
</template>

<script>
export default {
  methods: {
    handleCreateExportProof () {
      this.$router.push('/export-proof-create')
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-export-proof-list-header {
    position: relative;
    padding: 0 $mainPadding;
    margin: 15px 0;
  }

</style>
